import { useLocale } from '@/context/localeContext'

export const hrcw = (t: ReturnType<typeof useLocale>['t']) => [
  {
    id: 'falling',
    description: t('swmsBuilder:hrcw.falling.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.falling.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.falling.htmlDescription.highlight')}
        </strong>
        {t('swmsBuilder:hrcw.falling.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'railway',
    description: t('swmsBuilder:hrcw.railway.description'),
    emoji: '🛤',
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.railway.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.railway.htmlDescription.highlight1')}
        </strong>{' '}
        {t('swmsBuilder:hrcw.railway.htmlDescription.or')}{' '}
        <strong>
          {t('swmsBuilder:hrcw.railway.htmlDescription.highlight2')}
        </strong>
        {t('swmsBuilder:hrcw.railway.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'liquids',
    description: t('swmsBuilder:hrcw.liquids.description'),
    emoji: '🌊',
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.liquids.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.liquids.htmlDescription.highlight1')}
        </strong>
        {t('swmsBuilder:hrcw.liquids.htmlDescription.middle')}
        <strong>
          {t('swmsBuilder:hrcw.liquids.htmlDescription.highlight2')}
        </strong>
      </>
    ),
  },
  {
    id: 'plant',
    emoji: '🏗',
    description: t('swmsBuilder:hrcw.plant.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.plant.htmlDescription.before')}
        <strong>{t('swmsBuilder:hrcw.plant.htmlDescription.highlight')}</strong>
        {t('swmsBuilder:hrcw.plant.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'collapse',
    description: t('swmsBuilder:hrcw.collapse.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.collapse.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.collapse.htmlDescription.highlight')}
        </strong>
      </>
    ),
  },
  {
    id: 'temperature',
    emoji: '❄️',
    description: t('swmsBuilder:hrcw.temperature.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.temperature.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.temperature.htmlDescription.highlight')}
        </strong>
      </>
    ),
  },
  {
    id: 'electrical',
    emoji: '🔌',
    description: t('swmsBuilder:hrcw.electrical.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.electrical.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.electrical.htmlDescription.highlight')}
        </strong>
        {t('swmsBuilder:hrcw.electrical.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'trench',
    emoji: '⛏',
    description: t('swmsBuilder:hrcw.trench.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.trench.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.trench.htmlDescription.highlight1')}
        </strong>{' '}
        {t('swmsBuilder:hrcw.trench.htmlDescription.or')}{' '}
        <strong>
          {t('swmsBuilder:hrcw.trench.htmlDescription.highlight2')}
        </strong>
        {t('swmsBuilder:hrcw.trench.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'gas',
    emoji: '🎛',
    description: t('swmsBuilder:hrcw.gas.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.gas.htmlDescription.before')}
        <strong>{t('swmsBuilder:hrcw.gas.htmlDescription.highlight')}</strong>
        {t('swmsBuilder:hrcw.gas.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'demolition',
    emoji: '🧨',
    description: t('swmsBuilder:hrcw.demolition.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.demolition.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.demolition.htmlDescription.highlight')}
        </strong>
      </>
    ),
  },
  {
    id: 'confined',
    emoji: '📦',
    description: t('swmsBuilder:hrcw.confined.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.confined.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.confined.htmlDescription.highlight')}
        </strong>
        {t('swmsBuilder:hrcw.confined.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'chemical',
    emoji: '🧪',
    description: t('swmsBuilder:hrcw.chemical.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.chemical.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.chemical.htmlDescription.highlight1')}
        </strong>
        ,{' '}
        <strong>
          {t('swmsBuilder:hrcw.chemical.htmlDescription.highlight2')}
        </strong>{' '}
        {t('swmsBuilder:hrcw.chemical.htmlDescription.or')}{' '}
        <strong>
          {t('swmsBuilder:hrcw.chemical.htmlDescription.highlight3')}
        </strong>
        {t('swmsBuilder:hrcw.chemical.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'concrete',
    description: t('swmsBuilder:hrcw.concrete.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.concrete.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.concrete.htmlDescription.highlight1')}
        </strong>{' '}
        {t('swmsBuilder:hrcw.concrete.htmlDescription.or')}{' '}
        <strong>
          {t('swmsBuilder:hrcw.concrete.htmlDescription.highlight2')}
        </strong>{' '}
        {t('swmsBuilder:hrcw.concrete.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'telecommunication',
    emoji: '📡',
    description: t('swmsBuilder:hrcw.telecommunication.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.telecommunication.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.telecommunication.htmlDescription.highlight')}
        </strong>
        {t('swmsBuilder:hrcw.telecommunication.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'diving',
    emoji: '🤿',
    description: t('swmsBuilder:hrcw.diving.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.diving.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.diving.htmlDescription.highlight')}
        </strong>
      </>
    ),
  },
  {
    id: 'asbestos',
    description: t('swmsBuilder:hrcw.asbestos.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.asbestos.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.asbestos.htmlDescription.highlight')}
        </strong>
        <br />
        <i>
          <small>{t('swmsBuilder:hrcw.asbestos.htmlDescription.note')}</small>
        </i>
      </>
    ),
  },
  {
    id: 'flammable',
    emoji: '🔥',
    description: t('swmsBuilder:hrcw.flammable.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.flammable.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.flammable.htmlDescription.highlight1')}
        </strong>{' '}
        {t('swmsBuilder:hrcw.flammable.htmlDescription.or')}{' '}
        <strong>
          {t('swmsBuilder:hrcw.flammable.htmlDescription.highlight2')}
        </strong>
        {t('swmsBuilder:hrcw.flammable.htmlDescription.after')}
      </>
    ),
  },
  {
    id: 'explosives',
    emoji: '💣',
    description: t('swmsBuilder:hrcw.explosives.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.explosives.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.explosives.htmlDescription.highlight')}
        </strong>
      </>
    ),
  },
  {
    id: 'tunnel',
    description: t('swmsBuilder:hrcw.tunnel.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.tunnel.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.tunnel.htmlDescription.highlight')}
        </strong>
      </>
    ),
  },
  {
    id: 'silica',
    emoji: '💎',
    description: t('swmsBuilder:hrcw.silica.description'),
    htmlDescription: (
      <>
        {t('swmsBuilder:hrcw.silica.htmlDescription.before')}
        <strong>
          {t('swmsBuilder:hrcw.silica.htmlDescription.highlight')}
        </strong>
        {t('swmsBuilder:hrcw.silica.htmlDescription.after')}
      </>
    ),
  },
]
